module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii-7712dcd2eed9af9cd08a7b20c3c03744.jpg";